import DynamicCameraLocalization from './dynamic-camera-relocalization/DynamicCameraLocalization';
import Mesh from './mesh/Mesh';
import Museum from './museum/Museum';
import PathTracer from './path-tracer/PathTracer';
import Simulation from './simulation/Simulation';
import StyLit from './stylit/StyLit';

export default [
  StyLit,
  PathTracer,
  DynamicCameraLocalization,
  Mesh,
  Museum,
  Simulation,
];
